import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import '../common/Tile.css';

const tiles = [
	{
		icon: '🏢',
		title: 'Add Building',
		description: 'Add a new building to the system',
		url: 'add',
		access_roles: ['RT_Admin'] // Default to admin
	},
	{
		icon: '📋',
		title: 'View Buildings',
		description: 'See all buildings and their details',
		url: 'list',
		access_roles: ['RT_Admin'] // Default to admin
	}
];

const BuildingManagement = () => {
	const navigate = useNavigate();
	const location = useLocation();

	return (
		<div className="rt-layout">
			<Menu className="rt-menu" activePath={location.pathname} />
			<div className="rt-main-content">
				<div className="rt-title-row">
					<h2 className="rt-title">Building Management</h2>
				</div>
				<div className="rt-main-section">
					<div className="rt-tiles-grid">
						{tiles.map((tile, idx) => (
							<Tile
								key={idx}
								icon={tile.icon}
								title={tile.title}
								description={tile.description}
								disabled={tile.disabled}
								access_roles={tile.access_roles}
								onClick={() => tile.url && navigate(tile.url)}
								tabIndex={0}
								role="button"
								onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default BuildingManagement;